import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "login-component" }
const _hoisted_2 = { class: "title-width" }
const _hoisted_3 = {
  key: 0,
  style: {"margin-bottom":"1rem"}
}
const _hoisted_4 = {
  key: 1,
  style: {"padding-bottom":"20px"}
}
const _hoisted_5 = {
  key: 0,
  style: {"padding":"0px 40px 20px"}
}
const _hoisted_6 = { style: {"border":"1px solid #ddd","padding":"8px 12px","background-color":"#fafafa"} }
const _hoisted_7 = { class: "input-width" }
const _hoisted_8 = {
  class: "form-group",
  style: {"margin-bottom":"0"}
}
const _hoisted_9 = { for: "nameInput" }
const _hoisted_10 = { class: "password-wrap" }
const _hoisted_11 = { for: "passwordInput" }
const _hoisted_12 = {
  key: 1,
  class: "alert alert-danger center-in-flex"
}
const _hoisted_13 = { class: "check-wrap" }
const _hoisted_14 = {
  class: "form-check",
  style: {"padding-left":"0"}
}
const _hoisted_15 = {
  class: "form-check-label",
  for: "loginCheck",
  style: {"padding-left":"4px"}
}
const _hoisted_16 = { class: "input-width" }
const _hoisted_17 = { style: {"padding-top":"1.5rem"} }
const _hoisted_18 = { class: "sign-up-link" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.title)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.title), 1))
        : _createCommentVNode("", true),
      (_ctx.$root.account.isLogin)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$root.account.info.userName) + "としてログイン中です。", 1))
        : _createCommentVNode("", true)
    ]),
    (_ctx.requestMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.requestMessage), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("form", null, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$root.messages.login.mail), 1),
          _withDirectives(_createElementVNode("input", {
            class: "form-control",
            id: "nameInput",
            name: "username",
            type: "email",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formLogin.name) = $event)),
            onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.submitLogin && _ctx.submitLogin(...args)), ["enter"])),
            autocomplete: "email",
            autofocus: ""
          }, null, 544), [
            [_vModelText, _ctx.formLogin.name]
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$root.messages.login.password), 1),
          _withDirectives(_createElementVNode("input", {
            class: "form-control",
            id: "passwordInput",
            type: "password",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formLogin.password) = $event)),
            onKeyup: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.submitLogin && _ctx.submitLogin(...args)), ["enter"])),
            autocomplete: "current-password"
          }, null, 544), [
            [_vModelText, _ctx.formLogin.password]
          ])
        ])
      ])
    ]),
    (_ctx.hasLoginError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, _cache[6] || (_cache[6] = [
          _createElementVNode("small", null, "メールアドレスまたはパスワードが正しくありません", -1)
        ])))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _withDirectives(_createElementVNode("input", {
          id: "loginCheck",
          type: "checkbox",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formLogin.rememberMe) = $event)),
          class: "form-checkbox"
        }, null, 512), [
          [_vModelCheckbox, _ctx.formLogin.rememberMe]
        ]),
        _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$root.messages.login.keep), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("button", {
        class: "btn btn-primary login-button",
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.submitLogin && _ctx.submitLogin(...args)))
      }, "ログイン")
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createVNode(_component_router_link, {
        onClick: _ctx.onClickLink,
        target: _ctx.linkTarget,
        to: "/forgot/password/"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$root.messages.login.resetPassword), 1)
        ]),
        _: 1
      }, 8, ["onClick", "target"])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createVNode(_component_router_link, {
        onClick: _ctx.onClickLink,
        target: _ctx.linkTarget,
        to: "/signup"
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_ctx.$root.messages.login.toregistration), 1)
        ]),
        _: 1
      }, 8, ["onClick", "target"])
    ])
  ]))
}